import { useMemo } from 'react';
interface UsePricingCalculationsParams {
  selectedPlanMonthlyRate: number;
  selectedPlanBillingInterval: string;
  organizationDiscount: number;
}

interface PricingCalculations {
  discount: number;
  monthlyRate: number;
  monthlyRateWithDiscount: number;
  billingInterval: string;
}

/**
 * Hook for calculating pricing based on selected plan and add-ons
 */
export const usePricingCalculations = ({
  selectedPlanMonthlyRate,
  selectedPlanBillingInterval,
  organizationDiscount,
}: UsePricingCalculationsParams): PricingCalculations => {
  return useMemo(() => {
    const discount = organizationDiscount || 0;
    const monthlyRate = selectedPlanMonthlyRate
      ? selectedPlanMonthlyRate / 100.0
      : 0.0;
    const monthlyRateWithDiscount = monthlyRate * (1 - discount);

    const billingInterval = selectedPlanBillingInterval || 'monthly';

    return {
      discount,
      monthlyRate,
      monthlyRateWithDiscount,
      billingInterval,
    };
  }, [
    selectedPlanMonthlyRate,
    selectedPlanBillingInterval,
    organizationDiscount,
  ]);
};
